import { useDispatch, useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { useTranslation } from "react-i18next";
import { Button, Card, Col, Form, InputGroup, Modal, Row } from "react-bootstrap";

import "../../Assets/scss/pages/settings.scss";
import NoRecordFound from "../../Components/NoRecordFound";
import { useEffect, useMemo, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { useLocation, useNavigate } from "react-router-dom";
import { AddVoiceCommandService, deleteVoiceCommandService, getVoiceCommandService, UpdateVoiceCommandService } from "../../Services/VoiceCommandService";

interface PropTypes {
    disabledButton: boolean
}

// component to render settings page
const VoiceCommandPage = (prop: PropTypes) => {
  // Redux Data
  const { accessToken, currentWebsite, currentUserStatus } = useSelector(
    (store: StoreProptypes) => store
  );

  const { disabledButton } = prop;

  // Functions
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // useState
  const [voiceCommandListData, setVoiceCommandListData] = useState<any>();
  const location = useLocation();
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  useEffect(() => {
    if (accessToken && currentWebsite) {
      // service to get card list
      getVoiceCommandService(accessToken, currentWebsite?.id?.toString(), setVoiceCommandListData, dispatch, t);
    }
  }, [accessToken, currentWebsite]);

  // Show Card Popup
  const [voiceCommandTitle, setVoiceCommandTitle] = useState("");
  const [voiceCommandDescription, setVoiceCommandDescription] = useState<string[]>([""]);
  const [voiceCommandURL, setVoiceCommandURL] = useState("");
  const [editingVoiceCommand, setEditingVoiceCommand] = useState<any | null>(null);
  const [showVoiceCommandPopup, setShowVoiceCommandPopup] = useState(false);
  const [showDeleteVoiceCommandPopup, setDeleteVoiceCommandPopup] = useState(false);
  const [deleteVoiceCommandID, setDeleteVoiceCommandID] = useState<number | null>();

  // function to close Voice command popup
  const handleCloseVoiceCommandPopup = () => {
    setShowVoiceCommandPopup(false);
    resetVoiceCommandForm()
  };

  // function to show Voice Command popup
  const handleShowVoiceCommandPopup = () => {
    setShowVoiceCommandPopup(true);
  };

   // function to display delete card popup
  const handleShowDeleteVoiceCommandPopup = (id: number) => {
    setDeleteVoiceCommandPopup(true);
    id && setDeleteVoiceCommandID(id);
  };

  const validateVoiceCommand = () => {
    const newErrors: { [key: string]: string } = {};

    if (!voiceCommandTitle.trim()) {
      newErrors.voiceCommandTitle = t("Title is required");
    } else if (voiceCommandTitle.length > 100) {
      newErrors.voiceCommandTitle = t("Title cannot exceed 100 characters");
    }
    

    console.log('voiceCommandDescription: ', voiceCommandDescription);
    if (voiceCommandDescription.length <= 0) {
      newErrors.streetAddress = t("Alias is required");
    }

    setErrors(newErrors);
    console.log('newErrors: ', newErrors);

    return Object.keys(newErrors).length === 0;
  };

   const resetVoiceCommandForm = () => {
    setVoiceCommandTitle("");
    setVoiceCommandDescription([]);
    setVoiceCommandURL("");
    setEditingVoiceCommand(null); // exit edit mode
    setErrors({});
  };


  const handleEditVoiceCommand = (id: number) => {
    const getSelectedIdData = voiceCommandListData.find((d:any) => d.id === id)
    if (getSelectedIdData) {
      setVoiceCommandTitle(getSelectedIdData?.command_title)
      setVoiceCommandURL(getSelectedIdData?.command_value)
      setVoiceCommandDescription(getSelectedIdData.description)
      setEditingVoiceCommand(getSelectedIdData)
      handleShowVoiceCommandPopup()
    }
  }

  const saveVoiceNavigationCommand = (e: React.FormEvent) => {
    e.preventDefault();
    if (accessToken && (validateVoiceCommand()) && currentWebsite) {
      if (editingVoiceCommand) {
        UpdateVoiceCommandService(editingVoiceCommand.id, currentWebsite?.id?.toString(), voiceCommandTitle ,voiceCommandDescription.join(','), voiceCommandURL, accessToken,setVoiceCommandListData, setShowVoiceCommandPopup,  dispatch, t, resetVoiceCommandForm)
      } else {
        AddVoiceCommandService(currentWebsite?.id?.toString(), voiceCommandTitle ,voiceCommandDescription.join(','), voiceCommandURL, accessToken,setVoiceCommandListData, setShowVoiceCommandPopup,  dispatch, t, resetVoiceCommandForm)
      }
    }
  }

  const handleChange = (value: string, index: number) => {
      const updated = [...voiceCommandDescription];
      updated[index] = value;
      setVoiceCommandDescription(updated);
  };

  const handleAdd = () => {
      if (voiceCommandDescription.length < 10) {
      setVoiceCommandDescription([...voiceCommandDescription, ""]);
      }
  };

  const handleDelete = (index: number) => {
    const updated = voiceCommandDescription.filter((_, i) => i !== index);
    setVoiceCommandDescription(updated.length > 0 ? updated : [""]); // keep at least one input
  };

    // function to close card delete popup
  const handleCloseDeleteVoiceCommandPopup = () => {
    setDeleteVoiceCommandPopup(false);
    setDeleteVoiceCommandID(null);
  };

  // function to handle delete card
  const handleDeleteVoiceCommand = () => {
    // check if access token and delete card ID are available
    if (accessToken && deleteVoiceCommandID && currentWebsite) {
      // service to perform delete card
      deleteVoiceCommandService(
        accessToken,
        currentWebsite?.id?.toString(),
        deleteVoiceCommandID,
        setVoiceCommandListData,
        setDeleteVoiceCommandPopup,
        dispatch,
        t
      );
    }
  };

  return (
    <>
        <div className="manage-cards">
            <Card className="mt-3">
                <Card.Header>
                <h2 className="mb-0 h5">{t("Voice Command")}</h2>
                <Button
                    variant="primary"
                    disabled={disabledButton}
                    onClick={handleShowVoiceCommandPopup}
                    size="lg"
                    className="aioa_dashboard-icon-btn"
                >
                    <div className="aioa_dashboard-btn-icon">
                    <i
                        className="material-symbols-outlined"
                        aria-hidden="true"
                    >
                        add_home
                    </i>
                    </div>
                    <div className="aioa_dashboard-btn-text">
                    {t("Add New Voice Command")}
                    </div>
                </Button>
                </Card.Header>

                <Card.Body>
                <div className="credit-card-list">
                    {voiceCommandListData ? (
                    <>
                        {voiceCommandListData.length > 0 ? (
                        <>
                            <Row xl={2}>
                            {voiceCommandListData.map((voiceItem:any) => {
                                return (
                                <Col key={voiceItem.id}>
                                    <div
                                    className={`credit-card-box`}
                                    >
                                    <div
                                        className={`credit-card-details`}
                                    >
                                        <div className="credit-card-detail-box">
                                        <span>
                                            <strong className="ellipsis">
                                            {voiceItem.command_title}
                                            </strong>
                                        </span>
                                        <span className="ellipsis">
                                            { voiceItem.description.length > 0 ? voiceItem.description.join(',') : '' }
                                        </span>
                                        </div>
                                    </div>

                                    <div className="action-btns">
                                        <Button
                                            variant="primary"
                                            className="ms-3"
                                            disabled={disabledButton}
                                            aria-label={t(
                                            "Edit Billing Address"
                                            ).toString()}
                                            onClick={() =>
                                            handleEditVoiceCommand(
                                                voiceItem.id
                                            )
                                            }
                                        >
                                            <i
                                            className={`material-symbols-outlined`}
                                            aria-hidden="true"
                                            >
                                            edit
                                            </i>
                                        </Button>

                                        <Button
                                            variant="danger"
                                            aria-label={t(
                                            "Delete Billing Address"
                                            ).toString()}
                                            disabled={disabledButton}
                                            onClick={() =>
                                            handleShowDeleteVoiceCommandPopup(
                                                voiceItem.id
                                            )
                                            }
                                        >
                                            <i
                                            className={`material-symbols-outlined`}
                                            aria-hidden="true"
                                            >
                                            delete
                                            </i>
                                        </Button>
                                        </div>
                                    </div>
                                </Col>
                                );
                            })}
                            </Row>
                        </>
                        ) : (
                        <>
                            <div className="w-100">
                            <NoRecordFound
                                imageType={`card`}
                                joyful={false}
                                noRecordText={`No Voice Command.`}
                            />
                            </div>
                        </>
                        )}
                    </>
                    ) : (
                    <></>
                    )}
                </div>
                </Card.Body>
            </Card>
        </div>
      <Modal
        show={showVoiceCommandPopup}
        onHide={handleCloseVoiceCommandPopup}
        size="lg"
        // fullscreen="lg-down"
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          {editingVoiceCommand ?
          <Modal.Title>{t("Update Voice Command")}</Modal.Title>
          :
          <Modal.Title>{t("Add New Voice Command")}</Modal.Title>
          }
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={saveVoiceNavigationCommand}>
           <div className='card-input-group row'>
                <div className='col-12'>
                    <h5 className="">
                        {t("Command Title")}
                    </h5>
                  <InputGroup className="mt-3 input-group-outline">
                    <Form.Control
                      placeholder={`${t("Enter Command Name")}`}
                      aria-label={`${t("Title")}`}
                      type="text"
                      className="rounded-2"
                      size="lg"
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => setVoiceCommandTitle(e.target.value)}
                      value={voiceCommandTitle}
                      isInvalid={!!errors.voiceCommandTitle}
                      style={{ backgroundImage: "none", paddingRight: "0.75rem" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.voiceCommandTitle}
                    </Form.Control.Feedback>
                  </InputGroup>

                </div>
                <div className="col-12 mt-2">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h5 className="mt-2 ">
                          {t("Alias")}
                        </h5>
                      {voiceCommandDescription.length < 10 && (
                          <Button variant="primary" onClick={handleAdd}>
                          + {t("Add")}
                          </Button>
                      )}
                    </div>
                    <Form.Group
                      className="custom-statement mt-1 align-middle d-flex gap-2 flex-column"
                    >
                    {voiceCommandDescription.map((item, index) => (
                      <div className="d-flex align-items-center gap-2">
                        <Form.Control
                          size="lg"
                          type="text"
                          placeholder={t("Add Alias")}
                          value={item}
                          onChange={(e) => handleChange(e.target.value, index)}
                          />
                          {voiceCommandDescription.length > 1 && (
                          <Button
                              variant="danger"
                              className="h-50"
                              onClick={() => handleDelete(index)}
                              aria-label={t("Delete Voice Command")}
                          >
                              ✕
                          </Button>
                          )}
                      </div>
                    ))}
                    </Form.Group>
                </div>
                <div className='col-12'>
                    <h5 className="mt-3">
                        {t("URL")}
                    </h5>
                  <InputGroup className="mt-1 input-group-outline">
                    <Form.Control
                      placeholder={`${t("Enter the target URL")}`}
                      aria-label={`${t("URL")}`}
                      type="text"
                      className="rounded-2"
                      size="lg"
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => setVoiceCommandURL(e.target.value)}
                      value={voiceCommandURL}
                      isInvalid={!!errors.voiceCommandURL}
                      style={{ backgroundImage: "none", paddingRight: "0.75rem" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.voiceCommandURL}
                    </Form.Control.Feedback>
                  </InputGroup>
                </div>
            </div>
            <div className='card-save-btns d-flex m-2 justify-content-center'>
                <Button variant="primary" type="submit">
                    {/* {showCardPopupLoading ? <Spinner animation="grow" size='sm' className='me-2' /> : <></>} */}
                    {editingVoiceCommand ?
                      <span>
                          {t('Update')}
                      </span>
                     :
                      <span>
                          {t('Save Button Label')}
                      </span>
                     }
                </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        show={showDeleteVoiceCommandPopup}
        onHide={handleCloseDeleteVoiceCommandPopup}
        size="lg"
        // fullscreen="lg-down"
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Delete Voice Navigation")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("Are you sure want to delete voice navigation command?")}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleDeleteVoiceCommand}>
            {t("Delete Button Label")}
          </Button>
          <Button variant="danger" onClick={handleCloseDeleteVoiceCommandPopup}>
            {t("Close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default VoiceCommandPage;
